import {ClsAccessToken} from './cls-access-token';

export const BUSQUEDA_AI_TIPO_FILTERS = {
  TODOS: 'TODOS',
  MATERIALES: 'MATERIALES',
  MANO_DE_OBRA: 'MANO_DE_OBRA',
  EQUIPO: 'EQUIPO',
  OTROS: 'OTROS'
} as const;

export type BusquedaAITipoFilter = (typeof BUSQUEDA_AI_TIPO_FILTERS)[keyof typeof BUSQUEDA_AI_TIPO_FILTERS];

export const BUSQUEDA_AI_MATRIZ_FILTERS = {
  TODOS: 'TODOS',
  SOLO_MATRICES: 'SOLO_MATRICES',
  SOLO_INSUMOS: 'SOLO_INSUMOS'
} as const;

export type BusquedaAIMatrizFilter = (typeof BUSQUEDA_AI_MATRIZ_FILTERS)[keyof typeof BUSQUEDA_AI_MATRIZ_FILTERS];

export class ClsPeticionBusquedaAI {
  accessToken: ClsAccessToken;
  query: string;
  topK: number;
  useRerank?: boolean;
  filterTipo?: BusquedaAITipoFilter;
  filterMatriz?: BusquedaAIMatrizFilter;
}

export class ClsRespuestaVectorSearchResponse {
  ok!: boolean;
  type!: string;
  query!: string;
  topScore!: number;
  results!: ClsVectorSearchResult[];
  message?: string;
  smartHints?: ClsBusquedaAISmartHint[];
  smartMeta?: ClsBusquedaAISmartMeta;
  note?: string;
  error!: any;
}

export class ClsVectorSearchResult {
  score!: number;
  scoreOriginal?: number;
  smartScore?: number;
  smartReason?: string;
  row!: ClsVectorSearchRow;
  qualification!: string;
  qualificationNumeric!: number;
}

export class ClsVectorSearchRow {
  id!: string;
  idCatalogo!: string;
  codigo!: string;
  descripcion!: string;
  unidad!: string;
  tipo!: string;
  costo!: number;
  fecha!: Date;
  score?: number;
  scoreOriginal?: number;
  smartScore?: number;
  smartReason?: string;
  extra!: Record<string, any>;
  qualification!: string;
  qualificationNumeric!: number;
  esMatriz?: boolean;
}

export class ClsBusquedaAIFavorito {
  idFavorito!: string;
  id!: string;
  idCatalogo!: string;
  nivel!: number;
  codigo!: string;
  descripcion!: string;
  unidad!: string;
  tipo!: string;
  costo!: number;
  fecha!: Date;
  esMatriz = false;
  cantidad = 1;
  exportado = false;
  destinosExportados: MiPresupuestoDestinoExportado[] = [];
  fechaUltimoEnvio?: Date;
}

export type MiPresupuestoDestinoExportado = 'partida' | 'matriz' | 'catalogo';

export class ClsBusquedaAISmartMeta {
  useRerank!: boolean;
  candidateCount!: number;
  provider?: 'embeddings' | 'fallback' | 'gemini' | 'guard';
  intent?: any;
}

export class ClsBusquedaAIResultado {
  data: ClsVectorSearchRow[] = [];
  smartHints: ClsBusquedaAISmartHint[] = [];
  smartMeta?: ClsBusquedaAISmartMeta;
  message?: string;
}

export class ValidationErrorDetail {
  code: string;
  values: string[];
  path: string[];
  message: string;

  constructor(data: any) {
    this.code = data.code;
    this.values = data.values || [];
    this.path = data.path || [];
    this.message = data.message;
  }
}

export class ClsBusquedaAISmartHint {
  id!: string;
  severity!: 'info' | 'warning' | 'success';
  title!: string;
  message!: string;
  actionLabel?: string;
  recommendedFilters?: {
    filterTipo?: BusquedaAITipoFilter;
    filterMatriz?: BusquedaAIMatrizFilter;
  };
}
